import React from "react"
import { navigationLogoBig } from "../../../../../../static/svgs/navigation"

type Props = {
  onClick: () => void
}

const NavigationLogo = ({ onClick }: Props) => (
  <img
    alt="nanofind-logo"
    className="cursor-pointer absolute left-1/2 transform -translate-x-1/2 h-full py-1"
    onClick={onClick}
    src={navigationLogoBig}
    style={{ flex: "0 1 auto" }}
  />
)

export default NavigationLogo
